import { Routes, Route, Navigate } from 'react-router-dom';
import NotFoundPage from 'pages/NotFoundPage';
import routes from './routes';
import LoginRoute from './LoginRoute';
import PrivateRoute from './PrivateRoute';

const Router = () => (
  <Routes>
    {routes.public?.map(route => (
      <Route exact key={route.path} path={route.path} element={route.component} />
    ))}
    {routes.private?.map(route => (
      <Route
        exact
        key={route.path}
        path={route.path}
        element={<PrivateRoute category={route?.category} />}
      >
        <Route exact path={route.path} element={route.component} />
      </Route>
    ))}
    <Route exact path="/" element={<Navigate replace to="/orders" />} />
    <Route exact path="/login" element={<LoginRoute />} />
    <Route exact path="*" element={<NotFoundPage />} />
  </Routes>
);

export default Router;
